<template>
    <div class="root h-100">
        <Navigation ref="navigation" />
        <Overlay v-if="overlayDisplay" />
        <router-view />
        <component :is="'script'">
            function loadScript(a){var b=document.getElementsByTagName("head")[0],c=document.createElement("script");c.type="text/javascript",c.src="https://tracker.metricool.com/resources/be.js",c.onreadystatechange=a,c.onload=a,b.appendChild(c)}
            loadScript(function(){beTracker.t({hash:"c25b088186916e1642d1668b1370aff0"})});
        </component>
    </div>
</template>

<script>
import { eventBus } from "./main";

import { gsap } from "gsap"
import { TimelineLite, Sine } from "gsap"

import Navigation from "@/components/Navigation.vue";
import Overlay from "@/components/Overlay.vue";

gsap.registerPlugin();

export default {
    components: {
        Navigation,
        Overlay
    },
    data() {
        return {
            overlayDisplay: true,
            timeline_nav: ''
        }
    },
    metaInfo() {
        return {
            title: 'Ozmo | Diseño de futuros',
            meta: [
                {name: 'description', content: 'Consultora en Innovación Estratégica'},
                {name: 'keywords', content: 'consultora en innovación estratégica, consultora de innovación, agencia de transformación estratégica, consultora de cultura organizacional, consultoría en transformación para empresas, consultoría en cultura organizacional, proveedores de design thinking, agencias de investigación de usuarios, talleres para diseñar experiencias, consultoras con experiencia en área de capital humano, consultoras en innovación con experiencia sector financiero, agencia de innovación empresarial'},
                {name: 'robots', content: 'index,follow'},
                {name: 'viewport', content: 'width=device-width,initial-scale=1,user-scalable=no' },
                {charset: 'utf-8' },
                {property: 'og:title', content: 'Bienvenido a Ozmo'},
                {property: 'og:site_name', content: 'Ozmo | Diseño de futuros'},
                {property: 'og:description', content: 'Consultora en Innovación Estratégica'},
                {property: 'og:url', content: 'https://ozmo.mx'},
                {property: 'og:type', content: 'website'},
                {property: 'og:image', content: 'https://s3-us-west-2.amazonaws.com/cdn.ozmo.mx/ozmo_coral.png'}
            ]
        }
    },
    mounted() {
        this.timeline_nav = new TimelineLite()

        this.timeline_nav.set('.sideMenu', {autoAlpha:0,x:999})
        this.timeline_nav.set('.sideOverlay', {autoAlpha:0})

    },
    created() {
        eventBus.$on("closeNavigation", () => {
            this.displayNavigation(false);
        }),
        eventBus.$on("displayNavigation", () => {
            this.displayNavigation(true);
        }),
        eventBus.$on("closeOverlay", () => {
            this.displayOverlay(false);
        }),
        eventBus.$on("displayOverlay", () => {
            this.displayOverlay(true);
        }),
        eventBus.$on("gotoNavigation", navigation => {
            this.$router.push(navigation)
        });
    },
    methods: {
        displayNavigation(data) {
            if(data) {

                this.timeline_nav.to('.sideOverlay', 0.5, {
                    ease: Sine.easeInOut,
                    autoAlpha: 1
                })

                this.timeline_nav.to('.sideMenu', 0.5, {
                    ease: Sine.easeInOut,
                    autoAlpha: 1,
                    x:0
                })

            
            } else {

                this.timeline_nav.to('.sideMenu', 0.5, {
                    ease: Sine.easeInOut,
                    autoAlpha: 0,
                    x:999
                })

                this.timeline_nav.to('.sideOverlay', 0.5, {
                    ease: Sine.easeInOut,
                    autoAlpha: 0
                })

                
            }
        },
        displayOverlay(data) {
            this.overlayDisplay = data;
        }
    }
}
</script>

<style lang="stylus">

.root, #app
    -webkit-font-smoothing antialiased
    -moz-osx-font-smoothing grayscale


</style>
